import type { TComponent } from 'utils/types/component';

interface IMerchantsCellProps {
    merchantNames: string[];
}

export const MerchantsCell: TComponent<IMerchantsCellProps> = (props) => {
    const { merchantNames } = props;

    if (!merchantNames?.length) {
        return <span>-</span>;
    }

    return (
        <>
            {merchantNames.map((merchantName) => (
                <div key={merchantName}>{merchantName}</div>
            ))}
        </>
    );
};
